import { Fragments } from "../Types";

const cogentCopy: Fragments = {
  advisorTitle: "Cogent Advisor",
  companyName: "Cogent",
};

export default cogentCopy;
